var _a;
import { __assign } from "tslib";
import { deviationSchema } from '../normalizr/schemas/deviation';
import set from 'lodash/set';
import { userSchema } from '../normalizr/schemas/user';
import { galleryFolderSchema, collectionFolderSchema, } from '../normalizr/schemas/folder';
// we want to preserve expandables if the incoming entity was not expanded
// otherwise, overwrite everything
function preserveExisting(existing, incoming) {
    if (existing !== undefined && incoming === undefined) {
        return existing;
    }
    return incoming;
}
function mergeTextContent(existing, incoming) {
    if (!existing || !incoming) {
        return incoming;
    }
    // if the existing is expanded, and the incoming is not, keep the existing
    // do not attempt to merge to avoid tearing between excerpt and markup
    if (existing.html.markup !== undefined &&
        incoming.html.markup === undefined) {
        return existing;
    }
    return incoming;
}
function dropUndefined(thing) {
    var copy = {};
    Object.keys(thing).forEach(function (key) {
        if (thing[key] !== undefined) {
            copy[key] = thing[key];
        }
    });
    return copy;
}
function mergeDeviationEntity(existing, incoming) {
    var merged = __assign(__assign({}, incoming), { textContent: mergeTextContent(existing.textContent, incoming.textContent), dailyDeviation: preserveExisting(existing.dailyDeviation, incoming.dailyDeviation), print: preserveExisting(existing.print, incoming.print), pcp: preserveExisting(existing.pcp, incoming.pcp), background: preserveExisting(existing.background, incoming.background), extended: preserveExisting(existing.extended, incoming.extended), suggestedReasons: preserveExisting(existing.suggestedReasons, incoming.suggestedReasons) });
    return dropUndefined(merged);
}
// groups are stupid and we need to fully merge the extended data
function mergedExtendedGroup(existing, incoming) {
    var _a, _b, _c;
    if (!existing || !incoming) {
        return incoming !== null && incoming !== void 0 ? incoming : existing;
    }
    var existingApps = existing.apps;
    var incomingApps = incoming.apps;
    if (!existingApps || !incomingApps) {
        return __assign(__assign(__assign({}, existing), incoming), { apps: incomingApps !== null && incomingApps !== void 0 ? incomingApps : existingApps });
    }
    var merged = __assign(__assign(__assign({}, existing), incoming), { apps: dropUndefined(__assign(__assign({}, incomingApps), { gallery: (_a = incomingApps.gallery) !== null && _a !== void 0 ? _a : existingApps.gallery, posts: (_b = incomingApps.posts) !== null && _b !== void 0 ? _b : existingApps.posts, join: (_c = incomingApps.join) !== null && _c !== void 0 ? _c : existingApps.join })) });
    return dropUndefined(merged);
}
function mergeUserEntity(existing, incoming) {
    var _a, _b, _c, _d, _e, _f;
    // we need to preserve this one especially because it might be absent even
    // when all other things in the expand are present
    var latestPostTs = (_c = (_b = (_a = existing.extendedGroup) === null || _a === void 0 ? void 0 : _a.apps) === null || _b === void 0 ? void 0 : _b.posts) === null || _c === void 0 ? void 0 : _c.latestPostTs;
    var merged = __assign(__assign({}, incoming), { details: preserveExisting(existing.details, incoming.details), geo: preserveExisting(existing.geo, incoming.geo), profile: preserveExisting(existing.profile, incoming.profile), stats: preserveExisting(existing.stats, incoming.stats), isWatching: preserveExisting(existing.isWatching, incoming.isWatching), isBirthweek: preserveExisting(existing.isBirthweek, incoming.isBirthweek), networkbar: preserveExisting(existing.networkbar, incoming.networkbar), extendedGroup: mergedExtendedGroup(existing.extendedGroup, incoming.extendedGroup) });
    if (latestPostTs && !((_f = (_e = (_d = merged.extendedGroup) === null || _d === void 0 ? void 0 : _d.apps) === null || _e === void 0 ? void 0 : _e.posts) === null || _f === void 0 ? void 0 : _f.latestPostTs)) {
        set(merged, 'extendedGroup.apps.posts.latestPostTs', latestPostTs);
    }
    return dropUndefined(merged);
}
function mergeGallectionEntity(existing, incoming) {
    var merged = __assign(__assign({}, incoming), { totalItemCount: preserveExisting(existing.totalItemCount, incoming.totalItemCount), hasSubfolders: preserveExisting(existing.hasSubfolders, incoming.hasSubfolders), subfolders: preserveExisting(existing.subfolders, incoming.subfolders) });
    return dropUndefined(merged);
}
export var entityMergers = (_a = {},
    _a[deviationSchema.key] = mergeDeviationEntity,
    _a[userSchema.key] = mergeUserEntity,
    _a[galleryFolderSchema.key] = mergeGallectionEntity,
    _a[collectionFolderSchema.key] = mergeGallectionEntity,
    _a);
//# sourceMappingURL=mergeStrategies.js.map